import { render, staticRenderFns } from "./SubtitleAssetForm.vue?vue&type=template&id=d54c239c&scoped=true&"
import script from "./SubtitleAssetForm.vue?vue&type=script&lang=js&"
export * from "./SubtitleAssetForm.vue?vue&type=script&lang=js&"
import style0 from "./SubtitleAssetForm.vue?vue&type=style&index=0&id=d54c239c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54c239c",
  null
  
)

export default component.exports